<script>
  import SimpleCardDialog from '../parts/dialog/SimpleCardDialog'
  import ActionButton from '../parts/button/ActionButton'

  export default {
    components: { ActionButton, SimpleCardDialog },
    props: {
      modelValue: Boolean,
      currentData: {
        type: Object,
        default: null
      }
    },
    emits: ['reload', 'update:model-value'],
    data: () => ({
      api: null,
      formData: {},
      count: 0,
      model: false,
      browserReload: false
    }),
    watch: {
      modelValue () {
        this.model = this.modelValue
      },
      model () {
        this.$emit('update:model-value', this.model)
        if (this.model === false) {
          this.resetForm()
        }
      }
    },
    methods: {
      reload () {
        this.$emit('reload')
      },
      resetForm () {
        this.$store.dispatch('clearErrorRes')
        // TODO: reset the form data of UserForm in CreateEditUserDialog?
        // setTimeout(() => {
        //   this.$refs.form.reset()
        // }, 500)
      },
      updateFormData (data) {
        this.formData = data
      },
      submit () {
        if (this.currentData) {
          return this.$http.put(`/${this.api}/${this.currentData.id}/`, this.formData)
            .then((res) => {
              this.model = false
              if (this.browserReload) {
                location.reload()
              } else {
                this.$emit('reload')
              }
              return res
            })
            .catch(error => {
              // Ensure error is propagated
              throw error
            })
        } else {
          return this.$http.post(`/${this.api}/`, this.formData)
            .then((res) => {
              this.model = false
              if (this.browserReload) {
                location.reload()
              } else {
                this.$emit('reload')
              }
              return res
            })
            .catch(error => {
              // Ensure error is propagated
              throw error
            })
        }
      }
    }
  }
</script>
